import { RedactedTaxIdentifierSchema } from "@redotech/redo-model/outbound-labels/customs";
import * as z from "zod";
import { null as zNull } from "zod";
// we should never send the tax identifier number to the client
export const getTaxIdentifiers = {
  name: "getTaxIdentifiers" as const,
  input: zNull(),
  output: z.object({ identifiers: z.array(RedactedTaxIdentifierSchema) }),
};
